export {default} from './PeopleListContent';
